import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { memoizeFunction } from "@fluentui/react/lib/Utilities";

export interface HiddenRendererClassNames {
  root: string;
  childrenContainer: string;
}

export const getHiddenRendererClassNames = memoizeFunction(
  (): HiddenRendererClassNames => {
    return mergeStyleSets({
      root: {
        position: "fixed",
        visibility: "hidden",
      },
      childrenContainer: {
        position: "relative",
      },
    });
  }
);
